export const tutorProfile = {
  name: 'Dr. Sarah Mitchell',
  email: 'sarah.mitchell@computinghub.com',
  subject: 'Computer Science',
  boards: ['AQA', 'OCR'],
  level: 'GCSE & A-Level',
  bio: 'Former Head of CS at Oakwood Academy with 12 years of teaching experience. Specialist in algorithms, data structures and exam technique.',
  rating: 4.9,
  totalStudents: 312,
  totalSessions: 48,
  avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20teacher%20headshot%20smiling%2C%20white%20background%2C%20academic%20setting&width=120&height=120&seq=tutor1&orientation=squarish',
};

export const tutorStats = [
  { label: 'My Students', value: '312', icon: 'ri-user-line' },
  { label: 'Sessions Done', value: '48', icon: 'ri-video-line' },
  { label: 'Avg. Rating', value: '4.9', icon: 'ri-star-line' },
  { label: 'Resources Shared', value: '27', icon: 'ri-folder-line' },
];

export const tutorSessions = [
  { id: 1, title: 'GCSE AQA Paper 1 Revision', date: '2026-04-12', time: '16:00', duration: '90 min', students: 22, maxStudents: 30, status: 'upcoming', level: 'GCSE', board: 'AQA', notes: 'Cover topics: Binary, Networks, Algorithms' },
  { id: 2, title: 'Python Programming Bootcamp', date: '2026-04-08', time: '14:00', duration: '120 min', students: 40, maxStudents: 40, status: 'completed', level: 'GCSE', board: 'AQA', notes: 'Completed — great engagement from students' },
  { id: 3, title: 'A-Level OCR Data Structures', date: '2026-04-18', time: '17:00', duration: '60 min', students: 12, maxStudents: 20, status: 'upcoming', level: 'A-Level', board: 'OCR', notes: 'Focus on stacks, queues and linked lists' },
  { id: 4, title: 'GCSE Mock Paper Walkthrough', date: '2026-03-28', time: '15:00', duration: '90 min', students: 35, maxStudents: 35, status: 'completed', level: 'GCSE', board: 'AQA', notes: 'Reviewed common mistakes in Paper 2' },
];

export const tutorStudents = [
  { id: 1, name: 'Aisha Patel', year: 'Year 11', board: 'AQA', level: 'GCSE', progress: 72, lastSeen: '2026-04-05', sessions: 8, email: 'aisha.patel@email.com' },
  { id: 2, name: 'Marcus Lee', year: 'Year 12', board: 'AQA', level: 'A-Level', progress: 85, lastSeen: '2026-04-04', sessions: 11, email: 'marcus.lee@email.com' },
  { id: 3, name: 'Sophie Williams', year: 'Year 10', board: 'OCR', level: 'GCSE', progress: 41, lastSeen: '2026-04-03', sessions: 3, email: 'sophie.w@gmail.com' },
  { id: 4, name: 'Priya Sharma', year: 'Year 11', board: 'AQA', level: 'GCSE', progress: 63, lastSeen: '2026-04-02', sessions: 6, email: 'priya.s@email.com' },
  { id: 5, name: 'Oliver Brown', year: 'Year 13', board: 'OCR', level: 'A-Level', progress: 90, lastSeen: '2026-04-05', sessions: 14, email: 'oliver.b@email.com' },
];

export const tutorMessages = [
  { id: 1, from: 'Aisha Patel', avatar: 'AP', message: 'Hi Dr. Mitchell, could you share the notes from today\'s session?', time: '2 hours ago', unread: true },
  { id: 2, from: 'Admin', avatar: 'AD', message: 'New session request: GCSE AQA Revision on April 20th at 4pm. Please confirm.', time: '5 hours ago', unread: true },
  { id: 3, from: 'Marcus Lee', avatar: 'ML', message: 'Thank you for the feedback on my algorithm question. Really helpful!', time: '1 day ago', unread: false },
  { id: 4, from: 'Sophie Williams', avatar: 'SW', message: 'I\'m struggling with binary search. Can we cover it in the next session?', time: '2 days ago', unread: false },
];

export const tutorResources = [
  {
    id: 1,
    title: 'AQA GCSE Revision Notes – Unit 1',
    type: 'PDF',
    size: '2.4 MB',
    uploaded: '2026-03-15',
    downloads: 145,
    subject: 'Binary, Networks, Algorithms',
    level: 'GCSE',
    board: 'AQA',
    visibility: 'Students Only',
    description: 'Comprehensive revision notes covering all Unit 1 topics. Ideal for Paper 1 preparation.',
    fileUrl: '',
    tags: 'revision, unit 1, binary, networks',
  },
  {
    id: 2,
    title: 'Python Cheat Sheet',
    type: 'PDF',
    size: '0.8 MB',
    uploaded: '2026-03-20',
    downloads: 203,
    subject: 'Python Programming',
    level: 'Both',
    board: 'All Boards',
    visibility: 'Public',
    description: 'Quick-reference cheat sheet covering Python syntax, data types, loops, functions and OOP.',
    fileUrl: '',
    tags: 'python, programming, cheat sheet',
  },
  {
    id: 3,
    title: 'Algorithm Flashcards',
    type: 'PDF',
    size: '1.2 MB',
    uploaded: '2026-04-01',
    downloads: 89,
    subject: 'Algorithms & Data Structures',
    level: 'GCSE',
    board: 'AQA',
    visibility: 'Students Only',
    description: 'Printable flashcards for key algorithms: bubble sort, merge sort, binary search and more.',
    fileUrl: '',
    tags: 'algorithms, flashcards, sorting, searching',
  },
  {
    id: 4,
    title: 'OCR A-Level Practice Questions',
    type: 'DOCX',
    size: '3.1 MB',
    uploaded: '2026-04-03',
    downloads: 67,
    subject: 'Data Structures, OOP, Functional Programming',
    level: 'A-Level',
    board: 'OCR',
    visibility: 'Students Only',
    description: 'Exam-style practice questions with mark schemes for A-Level OCR Computer Science.',
    fileUrl: '',
    tags: 'a-level, ocr, practice, exam questions',
  },
];
